import { STORY_VERSIONS, STORYBLOK_TOKENS } from '@monoimin/constants';

import type { Locales } from '@monoimin/sb-types';

export const getStoryblokApiParams = (
  preview: boolean,
  locale: Locales | 'default' = 'en',
  isClient?: boolean
) => {
  return {
    version: preview ? STORY_VERSIONS.DRAFT : STORY_VERSIONS.PUBLISHED,
    language: locale,
    token: preview
      ? STORYBLOK_TOKENS[isClient ? 'client' : 'server'].preview
      : STORYBLOK_TOKENS[isClient ? 'client' : 'server'].api,
  };
};
